import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import { DOCUMENTS_MAP } from '../constants/constants';
import UserDocument from './UserDocument';

const UserDocuments = () => {
  const agentsData = useSelector((state: RootState) => state?.agentDocumentSlice?.documentsData);

  const documents = agentsData?.filter(
    doc => DOCUMENTS_MAP[doc.documentType as keyof typeof DOCUMENTS_MAP]
  );

  if (!documents?.length) return null;

  return (
    <div className="bg-[--bg-blue] rounded">
      {documents.map((document, index) => (
        <UserDocument
          key={document?.documentRefId}
          document={document}
          isLastDocument={index === documents.length - 1}
        />
      ))}
    </div>
  );
};

export default UserDocuments;
